import { createStyles, makeStyles, Tooltip } from "@material-ui/core";

import { TTableColumn } from "../../types";

const useStyles = makeStyles(() =>
  createStyles({
    leftCol: {
      width: "1px",
    },
  }),
);

interface TableHeaderProps {
  columns: TTableColumn<any>[];
}

const TableHeader = ({ columns }: TableHeaderProps) => {
  const classes = useStyles();

  return (
    <>
      <colgroup>
        <col className={classes.leftCol} />
        {columns.map(column => (
          <col
            key={String(column.primaryKey)}
            style={{
              width: column.width || "auto",
              minWidth: column.minWidth || "auto",
            }}
          />
        ))}
        <col />
      </colgroup>
      <thead>
        <tr>
          <th />
          {columns.map(column => {
            return (
              <th
                key={String(column.primaryKey)}
                aria-label={column.helpText}
                style={{
                  textAlign: column.rightAlign ? "right" : "left",
                }}
              >
                <span
                  style={{
                    whiteSpace: !column.canBreakLabel ? "nowrap" : "normal",
                    marginRight: "5px",
                  }}
                >
                  {column.label &&
                    (column.helpText ? (
                      <Tooltip title={column.helpText} placement="top">
                        <span
                          dangerouslySetInnerHTML={{ __html: column.label }}
                        />
                      </Tooltip>
                    ) : (
                      <span
                        dangerouslySetInnerHTML={{ __html: column.label }}
                      />
                    ))}
                  {column.subLabel && <span>{column.subLabel}</span>}
                </span>
              </th>
            );
          })}
          <th />
        </tr>
      </thead>
    </>
  );
};

export default TableHeader;
